export default{life:{type:'life_change',display:'Life Changes / COVID-19 Status'}};